<template>
  <div class="fmt-tool">
    <div class="fmt-toolbar">
      <span class="fmt-label">{{ $t('tool.XmlFormatter.title') }}</span>
      <span class="fmt-spacer" />
      <el-button size="small" plain icon="el-icon-star-off" @click="loadSample">{{ $t("common.action.sample") }}</el-button>
      <el-button size="small" icon="el-icon-s-operation" @click="format">{{ $t("common.action.format") }}</el-button>
      <el-button size="small" icon="el-icon-s-fold" @click="compress">{{ $t("common.action.compress") }}</el-button>
      <el-button size="small" @click="toJson">→ JSON</el-button>
      <el-button size="small" plain icon="el-icon-document-copy" @click="doCopy">{{ $t("common.action.copy") }}</el-button>
      <el-button size="small" plain icon="el-icon-delete" @click="clearAll">{{ $t("common.action.clear") }}</el-button>
    </div>
    <el-input v-model="code" type="textarea" :rows="18" placeholder="<root><item>value</item></root>"
      class="fmt-textarea" @input="onInput" />
    <div class="fmt-status-bar">
      <span v-if="errorMsg" class="fmt-err"><i class="el-icon-warning" /> {{ errorMsg }}</span>
      <span v-else-if="code.trim()" class="fmt-ok"><i class="el-icon-circle-check" /> XML 有效 · {{ charCount }}</span>
      <span v-else class="fmt-hint">粘贴 XML 文本，点击格式化或转 JSON</span>
    </div>
  </div>
</template>

<script>
export default {
  name:'XmlFormatterTool', props:{ config:{ type:Object, default:()=>({}) } },
  data:()=>({ code:'', errorMsg:'', sample:`<?xml version="1.0" encoding="UTF-8"?>
<bookstore>
  <book category="编程">
    <title>JavaScript高级程序设计</title>
    <author>Matt Frisbie</author>
    <year>2020</year>
    <price currency="CNY">129.00</price>
  </book>
  <book category="编程">
    <title>深入浅出Vue.js</title>
    <author>刘博文</author>
    <year>2019</year>
    <price currency="CNY">79.00</price>
  </book>
  <book category="文学">
    <title>活着</title>
    <author>余华</author>
    <year>1993</year>
    <price currency="CNY">45.00</price>
  </book>
</bookstore>` }),
  computed: { charCount() { return this.code.length + ' 字符' } },
  methods:{
    onInput() { this.errorMsg = '' },
    parseXml(s) {
      const doc = new DOMParser().parseFromString(s, 'text/xml')
      const err = doc.querySelector('parsererror')
      if (err) throw new Error(err.textContent)
      return doc
    },
    format() {
      this.errorMsg = ''; if (!this.code.trim()) return
      try {
        const doc = this.parseXml(this.code)
        let out = ''
        // XML 声明
        if (doc.xmlVersion) out += '<?xml version="' + doc.xmlVersion + '" encoding="UTF-8"?>\n'
        out += this.fmtNode(doc.documentElement, 0)
        this.code = out.trim()
      } catch(e) { this.errorMsg = 'XML 解析失败: ' + e.message }
    },
    fmtNode(node, depth) {
      const indent = '  '.repeat(depth)
      // 属性字符串
      let attrs = ''
      if (node.attributes && node.attributes.length) {
        for (let i = 0; i < node.attributes.length; i++) {
          attrs += ' ' + node.attributes[i].name + '="' + this.escAttr(node.attributes[i].value) + '"'
        }
      }
      // 没有子节点
      if (!node.children || !node.children.length) {
        const text = (node.textContent || '').trim()
        if (!text) return indent + '<' + node.tagName + attrs + ' />\n'
        return indent + '<' + node.tagName + attrs + '>' + this.escXml(text) + '</' + node.tagName + '>\n'
      }
      // 判断是否纯文本子节点
      if (node.children.length === 1 && node.children[0].nodeType === 3) {
        const text = (node.textContent || '').trim()
        return indent + '<' + node.tagName + attrs + '>' + this.escXml(text) + '</' + node.tagName + '>\n'
      }
      // 混合或嵌套子节点
      let s = indent + '<' + node.tagName + attrs + '>\n'
      for (let i = 0; i < node.children.length; i++) {
        const child = node.children[i]
        if (child.nodeType === 1) {
          s += this.fmtNode(child, depth + 1)
        } else if (child.nodeType === 3) {
          const t = child.textContent.trim()
          if (t) s += '  '.repeat(depth + 1) + this.escXml(t) + '\n'
        }
      }
      s += indent + '</' + node.tagName + '>\n'
      return s
    },
    escXml(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') },
    escAttr(s) { return s.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;') },
    toJson() {
      this.errorMsg = ''; if (!this.code.trim()) return
      try {
        const doc = this.parseXml(this.code)
        this.code = JSON.stringify(this.nodeToJson(doc.documentElement), null, 2)
      } catch(e) { this.errorMsg = '转换失败: ' + e.message }
    },
    nodeToJson(node) {
      const obj = {}
      if (node.attributes.length) for (let a of node.attributes) obj['@' + a.name] = a.value
      for (let child of node.children) {
        const key = child.tagName
        const val = child.children.length || child.attributes.length ? this.nodeToJson(child) : child.textContent.trim()
        if (obj[key]) { if (!Array.isArray(obj[key])) obj[key] = [obj[key]]; obj[key].push(val) }
        else obj[key] = val
      }
      if (!node.children.length && !node.attributes.length) return node.textContent.trim()
      return obj
    },
    compress() {
      this.errorMsg = ''; if (!this.code.trim()) return
      try {
        const doc = this.parseXml(this.code)
        this.code = this.compressNode(doc.documentElement)
      } catch(e) { this.errorMsg = 'XML 压缩失败: ' + e.message }
    },
    compressNode(node) {
      let attrs = ''
      if (node.attributes && node.attributes.length) {
        for (let i = 0; i < node.attributes.length; i++) {
          attrs += ' ' + node.attributes[i].name + '="' + this.escAttr(node.attributes[i].value) + '"'
        }
      }
      if (!node.children || !node.children.length) {
        const text = (node.textContent || '').trim()
        return '<' + node.tagName + attrs + (text ? '>' + this.escXml(text) + '</' + node.tagName + '>' : '/>')
      }
      let s = '<' + node.tagName + attrs + '>'
      for (let i = 0; i < node.children.length; i++) {
        const child = node.children[i]
        if (child.nodeType === 1) {
          s += this.compressNode(child)
        } else if (child.nodeType === 3) {
          s += this.escXml(child.textContent)
        }
      }
      s += '</' + node.tagName + '>'
      return s
    },
    doCopy() {
      if (!this.code.trim()) { this.$message.warning(this.$t("common.status.noContent")); return }
      navigator.clipboard.writeText(this.code).then(() => this.$message.success(this.$t("common.status.copied")))
    },
    clearAll() { this.code = ''; this.errorMsg = '' },
    loadSample() { this.code = this.sample; this.errorMsg = '' },
    doAction(a) {
      if (a === 'format') this.format()
      if (a === 'compress') this.compress()
      if (a === 'copy') this.doCopy()
      if (a === 'clear') this.clearAll()
    }
  }
}
</script>

<style scoped>
.fmt-tool { display: flex; flex-direction: column; gap: 12px; }

.fmt-toolbar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.fmt-toolbar >>> .el-button + .el-button { margin-left: 0; }
.fmt-label { font-size: 13px; font-weight: 700; color: #1a1f36; }
.fmt-spacer { flex: 1; }

.fmt-textarea >>> textarea {
  font-family: 'JetBrains Mono','Fira Code','Consolas',monospace !important;
  font-size: 13px !important; line-height: 1.6 !important;
  border-radius: 10px; resize: vertical; min-height: 360px;
}

.fmt-status-bar { font-size: 12px; }
.fmt-err { color: #f56c6c; display: flex; align-items: center; gap: 4px; }
.fmt-ok { color: #67c23a; display: flex; align-items: center; gap: 4px; }
.fmt-hint { color: #c0c4cc; }
</style>
